import { ProcessStage, KnownProcessType } from '../../models/process-models';

export class ProcessFilter {
  stage: ProcessStage;
  startDate: Date;
  surveyName: string;
  processTypes: Array<KnownProcessType>;
  employeeId: number = 0;
  respondentId: number = 0;
  businessUnitId: number = 0;
  gradeId: number = 0;
}